module.exports = "/static/assets/1dfc1f73867cf8259be121b6b227a2c7.png";